module.exports = __webpack_public_path__ + "img/settings-wa.09c34a56.svg";